import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ForgeRockModule } from './app/forge-rock.module';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} 


  if(!(window !== window.parent && !window.opener)){
    platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  }else{
    platformBrowserDynamic().bootstrapModule(ForgeRockModule)
    .catch(err => console.log(err));
  }
  